import { useState } from "react";
import { OrderService } from "../../../services";
import { showErrorToast, showSuccessToast } from "../../../components";

const usePreOrder = (dispatch) => {
  const [modalStates, setModalStates] = useState({
    cancel: { loading: false, finished: false },
    approve: { loading: false, finished: false },
  });

  const [loadingExport, setLoadingExport] = useState(false);

  const requestApprovePreOrder = async (orderId) => {
    const ordersId = [orderId];
    try {
      setModalStates((prev) => ({
        ...prev,
        approve: { loading: true, finished: false },
      }));
      await OrderService.approveOrder(ordersId);
      setModalStates((prev) => ({
        ...prev,
        approve: { loading: false, finished: true },
      }));
    } catch (e) {
      setModalStates((prev) => ({
        ...prev,
        approve: { loading: false, finished: false },
      }));
      dispatch(showErrorToast(e.message));
    }
  };

  const requestCancelPreOrder = async (
    idOrIds,
    externalRequest,
    preOrderIds
  ) => {
    try {
      setModalStates((prev) => ({
        ...prev,
        cancel: { loading: true, finished: false },
      }));

      await OrderService.cancelOrder(idOrIds, externalRequest, preOrderIds);

      setModalStates((prev) => ({
        ...prev,
        cancel: { loading: false, finished: true },
      }));
    } catch (e) {
      setModalStates((prev) => ({
        ...prev,
        cancel: { loading: false, finished: false },
      }));

      dispatch(showErrorToast(e.message));
    }
  };

  const handleConfirmCancelPreOrder = (
    idOrIds,
    externalRequest,
    preOrderId
  ) => {
    requestCancelPreOrder(idOrIds, externalRequest, preOrderId);
  };

  const handleDownloadPredOrder = async (order) => {
    const orderId = [order];
    try {
      setLoadingExport(true);
      await OrderService.downloadSelectedData(orderId, "export.csv");

      dispatch(showSuccessToast(`Pré-pedido exportado com sucesso!`));
      setLoadingExport(false);
    } catch (e) {
      setLoadingExport(false);
      dispatch(showErrorToast(e.message));
    }
  };

  const resetModalState = (modalType) => {
    setModalStates((prev) => ({
      ...prev,
      [modalType]: { loading: false, finished: false },
    }));
  };

  const handleResetCancelState = () => resetModalState("cancel");
  const handleResetApprovalState = () => resetModalState("approve");

  return {
    modalStates,
    loadingExport,
    requestApprovePreOrder,
    requestCancelPreOrder,
    handleConfirmCancelPreOrder,
    handleDownloadPredOrder,
    handleResetCancelState,
    handleResetApprovalState,
  };
};

export default usePreOrder;
